import { render, staticRenderFns } from "./SendWhatsapp.vue?vue&type=template&id=566ea5df&scoped=true&"
import script from "./SendWhatsapp.vue?vue&type=script&lang=js&"
export * from "./SendWhatsapp.vue?vue&type=script&lang=js&"
import style1 from "./SendWhatsapp.vue?vue&type=style&index=1&id=566ea5df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566ea5df",
  null
  
)

export default component.exports